import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import classnames from 'classnames';
import { Modal, Loading, HoverableIconBtn } from 'ck-ui';
import styles from './ProductQuickView.module.scss';

const ProductQuickView = ({ handle, onAddToCart, isForcedSoldOut, isBundle, isMobile, isAddToProgress }) => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(null);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (show && content) {
      if (isMobile) {
        window.theme.createProductImgCarousel();
      }
      document.dispatchEvent(new Event('initCountDown'));
      window.theme.selectSize();
      window.theme.initAccordion();
      window.theme.initSocialShareButtons();
      window.theme.snapchatAccess(isForcedSoldOut);
      window.theme.initQuickViewAddToCart();
      // eslint-disable-next-line no-eval
      window.eval(content.innerScripts);
      // We dispatch after the eval as we need the props to be updated in the dom
      document.dispatchEvent(new Event('renderSizeChartToggle'));
      window.lazyloadPolyfill(document.querySelector('.quick-view'));

      const handleAddToCart = e => {
        onAddToCart(e.detail.variantId)();
        setShow(false);
      };
      window.addEventListener('addToBundle', handleAddToCart);

      return () => {
        window.removeEventListener('addToBundle', handleAddToCart);
      };
    }
  }, [show, content, isMobile, isForcedSoldOut, onAddToCart]);

  const onClose = () => {
    setShow(false);
  };
  const onOpen = async () => {
    setShow(true);
    if (!content) {
      const response = await axios.get(`/products/${handle}?view=quick${isBundle ? '&bundle=true' : ''}${isAddToProgress ? '&add_to_progress=true' : ''}`);

      // Extract the Scripts from the returned HTML so we can execute them
      const domString = response.data;
      let innerHtml = domString;
      let innerScripts = '';
      let match;
      // eslint-disable-next-line no-cond-assign
      while (match = /<script>([\s\S]*?)<\/script>/gmi.exec(innerHtml)) {
        const [tag, script] = match;
        innerHtml = innerHtml.replace(tag, '');
        innerScripts = `${innerScripts} \n ${script}`;
      }
      setContent({
        innerHtml,
        innerScripts
      });
    }
  };
  return (
    <>
      <HoverableIconBtn iconName="zoom" onClick={onOpen} text="Quick View" />
      <Modal show={show} onClose={onClose} className={styles.modal}>
        {content ? (
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{ __html: content.innerHtml }} />
        ) : (
          <div className={classnames(styles.loading, 'is-flex-centered')}>
            <Loading isLoading />
          </div>
        )}
      </Modal>
    </>
  );
};

ProductQuickView.propTypes = {
  handle: PropTypes.string.isRequired,
  isBundle: PropTypes.bool,
  isForcedSoldOut: PropTypes.bool,
  isMobile: PropTypes.bool,
  onAddToCart: PropTypes.func.isRequired,
  isAddToProgress: PropTypes.bool,
};

ProductQuickView.defaultProps = {
  isBundle: false,
  isForcedSoldOut: false,
  isMobile: false,
  isAddToProgress: false,
};

export { ProductQuickView };
